var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.7273 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.2727,0H2.1818A2.1882,2.1882,0,0,0,0,2.1818V17.4545H2.1818V2.1818H15.2727Zm3.2728,4.3636h-12A2.1884,2.1884,0,0,0,4.3636,6.5455V21.8182A2.1883,2.1883,0,0,0,6.5455,24h12a2.1882,2.1882,0,0,0,2.1818-2.1818V6.5455A2.1883,2.1883,0,0,0,18.5455,4.3636Zm0,17.4546h-12V6.5455h12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6185ec66171521667619fd49d53667e8.svg";
export { ForwardRef as ReactComponent };